import { Classroom } from "@models/ISchema";

/**
 * Builds the location code of a classroom as the concatenation of campus,
 * building, and classroom codes joined by " - " (e.g. "SCGO - EDFA - 101").
 * Missing or empty parts are omitted while preserving the
 * campus-building-classroom order (e.g. "SCGO - 101").
 */
export const getClassroomLocationCode = (classroom?: Classroom | null): string => {
  const codes = [classroom?.building?.campus?.code, classroom?.building?.code, classroom?.code];

  return codes.filter(code => !!code?.trim()).join(" - ");
};
